module.exports = __webpack_public_path__ + "img/kf_icon.e1624850.png";